import React from "react"
import { getLocalStorageValue, setLocalStorageValue } from "../utils/localStorageUtil"

const defaultState = {
  dark: false,
  toggleDark: () => { },
}

const ThemeContext = React.createContext(defaultState)

// Getting dark mode information from OS!
// You need macOS Mojave + Safari Technology Preview Release 68 to test this currently.
const supportsDarkMode = () =>
  window.matchMedia("(prefers-color-scheme: dark)").matches === true

class ThemeProvider extends React.Component {
  state = {
    dark: false,
  }

  toggleDark = () => {
    let dark = !this.state.dark
    console.log("Toggle theme to " + (dark ? "dark" : "light"));
    setLocalStorageValue("dark", JSON.stringify(dark))
    this.setState({ dark })
  }

  componentDidMount() {
    // Getting dark mode value from local Storage!
    const value = getLocalStorageValue("dark")
    const lsDark = value && JSON.parse(value)
    if (lsDark) {
      this.setState({ dark: lsDark })
    } else if (supportsDarkMode() && lsDark !== false) {
      this.setState({ dark: true })
    }
  }

  render() {
    const { children } = this.props
    const { dark } = this.state
    return <ThemeContext.Provider value={{dark, toggleDark: this.toggleDark}}>
      {children}
    </ThemeContext.Provider>
  }
}

export default ThemeContext

export { ThemeProvider }
